import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import WOW from 'wowjs';
import Recaptcha from 'react-recaptcha';

// Components
import Header from 'components/Header';
import Footer from 'components/Footer';

// Layout
import LayoutRoutes from 'components/LayoutRoutes';
import Drawer from 'components/Drawer';

const AppLayout = props => {
  const { routes } = props;

  const [drawerShow, setDrawerShow] = useState(false);

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, [])
  
  return (
    <div className="wrapper">
      {/* Meta */}
      <Meta />
      {/* Meta End */}

      {/* Header */}
      <Header drawerShow={drawerShow} setDrawerShow={setDrawerShow} />
      {/* Header End */}

      {/* Drawer */}
      <Drawer drawerShow={drawerShow} setDrawerShow={setDrawerShow} />
      {/* Drawer End */}

      {/* Main Content */}
      <main className="main-content">

        {/* Layout Routes Or Pages To Render */}
        <LayoutRoutes {...props} routes={routes} />
        {/* Layout Routes Or Pages To Render End */}

      </main>
      {/* Main Content End */}

      {/* Footer */}
      <Footer />
      {/* Footer End */}

      {/* Recaptcha */}
      <Recaptcha sitekey={process.env.REACT_APP_RECAPTCHA_KEY} />
      {/* Recaptcha End */}
    </div>
  )
};

export default AppLayout;

const Meta = () => (
  <Helmet>
    <title>Home</title>
    <meta name="description" content="Description of Home" />
  </Helmet>
);
